import axios from "axios";
import React from "react";
import { useEffect, useState } from "react";

const Giphy = () => {
  const [data, setData] = useState([]);
  const [iseLoading, setIsLoading] = useState();
  const [input, setInput] = useState()
  const [inputValue, setInputValue] = useState("")

  const fetchData = async () => {
    const results = await axios(
      `https://api.giphy.com/v1/gifs/search?api_key=sfJoNIbYEOS4pmyNpQe5lT4FkLd6xmAg&q=${input}&limit=30`
    );
    setIsLoading(false);
    console.log(results)
    setData(results.data.data);
  };

  useEffect(() => {
      fetchData();
  }, [input]);

  const showGifs = () => {
    return data.map((el) => {
      return (
        <div key={el.id} className="gif">
          <img src={el.images.fixed_height_small.url} />
        </div>
      );
    });
  };
  return (
    <div className="container gifs">
        <div className="search-bar">
            <input onChange={(event)=>setInputValue(event.target.value)} type="text" placeholder="search"/>
            <button onClick={()=> (setInput(inputValue), setIsLoading(true))}><i class="fa-solid fa-magnifying-glass"></i></button>
        </div>

      {iseLoading ? <p>Loading...</p>:data.map((el) => {
        return (
          <div key={el.id} className="gif">
            <img src={el.images.fixed_height_small.url} />
          </div>
        );
      })}
    </div>
  );
};
export default Giphy;
